import Vue from "vue";

export class Ipv6 {
    /**
     *
     * @param ipv6
     * @param mes
     * @param ano
     * @return {Promise<any>}
     */
    static buscar(ipv6, mes, ano) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("ipv6/busca", { ipv6, mes, ano })
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}
